import { useFieldInfo, useTsController } from "@ts-react/form";
import { useId } from "react";
import { Fieldset, type GetProps, styled, TextArea as TTextArea } from "tamagui";
const StyledTextArea = styled(TTextArea, {
  name: "TextAreaFieldTextArea",
  fontFamily: "$body",
  fontSize: "$body1",
  color: "$textDefault",
  placeholderTextColor: "$textSubtle",
  borderWidth: "$0.5",
  margin: "$0.5",
  focusStyle: {
    borderColor: "$borderIntense",
    borderWidth: "$1",
    margin: 0
  },
  variants: {
    tone: {
      default: {},
      negative: {
        borderColor: "$borderNegative",
        hoverStyle: {
          borderColor: "$borderNegativeHover"
        },
        focusStyle: {
          borderColor: "$borderNegativeStrong",
          borderWidth: "$1",
          margin: 0,
          hoverStyle: {
            borderColor: "$borderNegativeStrong"
          }
        }
      }
    }
  } as const,
  defaultVariants: {
    tone: "default"
  }
});
import { Label } from "../Typography";
import { FormError } from "./FormError";
import { useFormFieldOptions } from "./FormFieldOptionsProvider";
export const TextAreaField = (props: Pick<GetProps<typeof StyledTextArea>, "size" | "autoFocus" | "placeholder" | "height" | "overflow">) => {
  const {
    field,
    error,
    formState: {
      isSubmitting
    }
  } = useTsController<string>();
  const {
    label,
    isOptional,
    placeholder
  } = useFieldInfo();
  const {
    hideOptionalLabel
  } = useFormFieldOptions();
  const id = useId();
  const disabled = isSubmitting;
  return <Fieldset data-sentry-element="Fieldset" data-sentry-component="TextAreaField" data-sentry-source-file="TextAreaField.tsx">
      {label ? <Label htmlFor={id} size={props.size || "$3"} pb="$1" pl={0}>
          {label}
          {isOptional && !hideOptionalLabel ? ` (Optional)` : null}
        </Label> : null}
      <StyledTextArea id={id} tone={error ? "negative" : "default"} disabled={disabled} backgroundColor={disabled ? "$bgDisabledSubtle" : "$surface2"}
    // Empty string instead of undefined so that the component
    // does not transition from "unmanaged" to "managed" (which
    // displays an error log in the web console).
    value={field.value ?? ""} onChangeText={text => field.onChange(text)} onBlur={field.onBlur} ref={field.ref} placeholder={placeholder} key={`${id}_input`} rows={5} {...props} data-sentry-element="StyledTextArea" data-sentry-source-file="TextAreaField.tsx" />
      <FormError errorMessage={error?.errorMessage} data-sentry-element="FormError" data-sentry-source-file="TextAreaField.tsx" />
    </Fieldset>;
};